import React, { useId } from "react";
import { cn } from "../../lib/cn";

/** Verified shop schedule — single source for UI blocks site-wide. */
export const BUSINESS_HOURS = {
  rows: [
    { days: "Monday – Friday", hours: "8:30 AM – 5:30 PM" },
    { days: "Saturday", hours: "Closed" },
    { days: "Sunday", hours: "Closed" },
  ],
};

export default function BusinessHours({ className, compact, tone = "light" }) {
  const { rows } = BUSINESS_HOURS;
  const light = tone === "light";
  const headingId = useId();

  return (
    <section
      className={cn(
        "rounded-xl text-left",
        light
          ? "border border-slate-200 bg-white shadow-sm"
          : "border border-white/10 bg-white/[0.03]",
        compact ? "p-4" : "p-5 sm:p-6",
        className,
      )}
      aria-labelledby={headingId}
    >
      <h2
        id={headingId}
        className={cn(
          "mb-3 font-semibold",
          light ? "text-navy-900" : "text-white",
          compact ? "text-sm" : "text-base sm:text-lg",
        )}
      >
        Business hours
      </h2>
      <dl className="space-y-2.5">
        {rows.map((row) => (
          <div
            key={row.days}
            className={cn(
              "flex flex-col gap-0.5 pb-2.5 last:border-b-0 last:pb-0 sm:flex-row sm:items-baseline sm:justify-between sm:gap-4",
              light
                ? "border-b border-slate-200"
                : "border-b border-white/[0.06]",
            )}
          >
            <dt
              className={cn(
                light ? "text-slate-500" : "text-slate-400",
                compact ? "text-xs" : "text-sm",
              )}
            >
              {row.days}
            </dt>
            <dd
              className={cn(
                "font-medium",
                light ? "text-slate-700" : "text-slate-100",
                compact ? "text-xs" : "text-sm",
              )}
            >
              {row.hours}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
